import ProgressBar from "components/DesignSystem/ProgressBar/ProgressBar";
import { SolidCheck } from "components/icons/SolidCheck";
import { useEffect, useState } from "react";

const FakeProgress = ({
  isSuccess,
  isLoading,
  interval = 500,
  showUploadCompleted = true,
}: {
  isLoading?: boolean;
  isSuccess?: boolean;
  interval?: number;
  showUploadCompleted?: boolean;
}) => {
  const { progress, showSuccess } = useFakeProgress({
    isLoading,
    isSuccess,
    interval,
  });

  if (showSuccess && showUploadCompleted) {
    return (
      <div className="t-flex t-gap-1 t-items-center">
        <span className="t-text-green-80">
          <SolidCheck size="12" />
        </span>
        <span className="t-text-text-30 t-text-body-sm">Upload Completed</span>
      </div>
    );
  }

  return (
    <div className="t-flex t-items-center t-gap-3">
      <div className="t-w-full">
        <ProgressBar.Root type={isSuccess ? "green" : "primary"}>
          <ProgressBar.Indicator progress={progress} />
        </ProgressBar.Root>
      </div>
      <span className="t-text-neutral t-text-caption">{progress}%</span>
    </div>
  );
};

const useFakeProgress = ({
  isLoading = false,
  isSuccess = false,
  interval = 500,
}: {
  isLoading?: boolean;
  isSuccess?: boolean;
  interval?: number;
}) => {
  const [progress, setProgress] = useState(0);
  const [showSuccess, setShowSuccess] = useState(false);

  useEffect(() => {
    if (isLoading) {
      const timer = setInterval(() => {
        setProgress((prev) =>
          Math.min(prev + Math.floor(Math.random() * 11), 95)
        );
      }, interval);
      return () => clearInterval(timer);
    }
  }, [isLoading, interval]);

  useEffect(() => {
    if (isSuccess) {
      setProgress(100);
      const timer = setTimeout(() => {
        setShowSuccess(true);
      }, interval);
      return () => clearTimeout(timer);
    }
  }, [isSuccess, interval]);

  return { progress, showSuccess };
};

export { useFakeProgress, FakeProgress };
